import api from 'services/api';
import { ValidationProps } from './types';

export const validateTicket = ({ data, eventID }: ValidationProps) =>
	api.post('/tickets/validate', {
		ticket_ids: [data.id.toString()],
		event_id: eventID.toString(),
		slot_or_day_id: data.slot.toString(),
	});

// QR validation service that matches the React Native approach
export const validateEncryptedTicket = ({
	qrData,
	eventID,
}: {
	qrData: { user_id: number; code: string; ticketing_mode: string };
	eventID: number;
}) =>
	api.post('/tickets/qr_data/validate', {
		qr_data: qrData,
		event_id: eventID,
		time_slot_id: 0,
	});

export const undoCheckIn = ({ ticketId, eventID }: { ticketId: number; eventID: number }) =>
	api.post(`/tickets/${ticketId}/undo-check-in`, { event_id: eventID, today: true });

export const getScannedTicket = (ticketId: number) => api.get(`/tickets/${ticketId}`).then(({ data }) => data);

export interface Attendee {
	user_id: number;
	full_name: string;
	email: string;
}

export interface AttendeeTicket {
	id: number;
	order_number: string;
	ticket_type_name: string;
	ticket_type_color: string | null;
	event_name: string;
	validated: boolean;
	status: string;
	recipient: string;
	seat_id?: string | null;
}

export interface CheckInResponse {
	user_name: string;
	tickets: { ID: number }[] | null;
	errors: { ticket_id: number; ticket_type_name: string; error: { Error: string } }[] | null;
}

// for_scanner=true widens a scanner-grouped festival to all its shows, as the QR scan does.
export const searchAttendees = (eventId: number, search: string) =>
	api
		.get<Attendee[]>(
			`/events/${eventId}/attendees?search=${encodeURIComponent(search)}&page=1&per_page=20&for_scanner=true`
		)
		.then(({ data }) => data || []);

export const getAttendeeTickets = (eventId: number, userId: number) =>
	api
		.get<AttendeeTicket[]>(`/events/${eventId}/users/${userId}/tickets?for_scanner=true`)
		.then(({ data }) => data || []);

/*
 * The server reads time_slot_id (slot_or_day_id is ignored). 0 lets it pick the day itself: for a scanner
 * group it resolves today's show, the same way the QR scan does. dryRun asks for the verdict without writing.
 */
export const checkInTickets = ({
	ticketIds,
	eventId,
	dryRun = false,
}: {
	ticketIds: number[];
	eventId: number;
	dryRun?: boolean;
}) =>
	api
		.post<CheckInResponse>(`/tickets/validate${dryRun ? '?dry_run=true' : ''}`, {
			ticket_ids: ticketIds.map(String),
			event_id: String(eventId),
			time_slot_id: 0,
		})
		.then(({ data }) => data);
